import { ReactNode } from 'react';
import { withStyles, CheckboxIndicator } from 'vopay';
import styles from './Checkbox.module.scss';

const cn = withStyles(styles);

type CheckboxProps = {
  name: string;
  checked: boolean;
  label: ReactNode;
  disabled?: boolean;
  labelPosition?: 'left' | 'right';
  onChange: (checked: boolean) => void;
};

export default function Checkbox({ name, checked, label, disabled, labelPosition = 'left', onChange }: CheckboxProps) {
  const indicator = <CheckboxIndicator checked={checked} />;
  const labelEl = <span>{label}</span>;

  return (
    <label htmlFor={name} className={cn('checkbox', labelPosition === 'right' && 'labelPositionRight')}>
      {labelPosition === 'right' ? labelEl : indicator}

      <input
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={cn('visuallyHidden')}
        disabled={disabled}
      />

      {labelPosition === 'right' ? indicator : labelEl}
    </label>
  );
}
